import { render, staticRenderFns } from "./LocalAtendimento.vue?vue&type=template&id=626b042a&"
import script from "./LocalAtendimento.vue?vue&type=script&lang=js&"
export * from "./LocalAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports